import request from '@/config/axios'
import { getSealTokenConfig, LOG_PREFIX } from '@/config/seal.config'

/**
 * Seal 认证 API
 * 
 * 用途：管理 Seal-Token 的兑换和刷新
 */

export interface ExchangeTokenResponse {
  token: string
  expireTime: string
  expireMinutes: number
  userId: number
  tenantId: number
  enterpriseId?: number
}

/**
 * 兑换 Seal-Token（统一接口）
 * 
 * 使用当前的 Authorization Token 兑换 Seal-Token
 * 用于在打开 seal-core iframe 前获取专用 token
 * 
 * 🆕 统一接口：/api/v1/seal/auth/exchange-token
 * 兼容移动端和PC端，后端根据请求来源自动识别用户
 * 
 * @param enterpriseId 企业ID（可选）
 * @param expireMinutes Token 有效期（分钟），默认使用配置文件中的值
 * @returns Seal-Token 信息
 */
export function exchangeSealToken(enterpriseId?: number, expireMinutes?: number) {
  // 使用统一配置
  const config = getSealTokenConfig('pc')
  const finalExpireMinutes = expireMinutes || config.expireMinutes
  
  console.log(`${LOG_PREFIX} 📡 PC端兑换 Seal-Token, expireMinutes: ${finalExpireMinutes}, platform: ${config.platform}`)
  
  // ✅ axios 拦截器会自动添加 /portal 前缀
  const params = new URLSearchParams()
  if (enterpriseId) params.append('enterpriseId', enterpriseId.toString())
  params.append('expireMinutes', finalExpireMinutes.toString())
  
  return request.post<ExchangeTokenResponse>({
    url: `/api/v1/seal/auth/exchange-token?${params.toString()}`
  })
}

/**
 * 刷新 Seal-Token（与移动端逻辑保持一致）
 * 
 * 使用旧的 Seal-Token 刷新获取新 Token
 * 
 * @param oldToken 旧的 Seal-Token
 * @param expireMinutes 新 Token 有效期（分钟），默认使用配置文件中的值
 * @returns 新的 Seal-Token 信息
 */
export function refreshSealToken(oldToken: string, expireMinutes?: number) {
  // 🆕 使用统一配置（与移动端一致）
  const config = getSealTokenConfig('pc')
  const finalExpireMinutes = expireMinutes || config.expireMinutes
  
  console.log(`${LOG_PREFIX} 🔄 PC端刷新 Seal-Token, expireMinutes: ${finalExpireMinutes}`)
  
  // ✅ axios 拦截器会自动添加 /portal 前缀
  const params = new URLSearchParams()
  params.append('oldToken', oldToken)
  params.append('expireMinutes', finalExpireMinutes.toString())
  
  return request.post<ExchangeTokenResponse>({
    url: `/api/v1/seal/auth/refresh-token?${params.toString()}`
  })
}

